export default __webpack_public_path__ + "static/media/Reservation.4e440027.svg";